import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IAbstractView, ILanguageObject } from '@core/interfaces';
import { ModifiersPresenter } from './singleproduct-modifiers.presenter';
import { IModifiersComponent } from './interfaces';
import { ModifierGroupWrapper, ModifierDetail } from '@core/models';

@Component({
  selector: 'app-singleproduct-modifiers',
  templateUrl: './singleproduct-modifiers.component.html',
  styleUrls: ['./singleproduct-modifiers.component.scss'],
  standalone: false,
  providers: [ModifiersPresenter]
})
export class ModifiersComponent 
  extends IAbstractView<ModifiersPresenter> 
  implements IModifiersComponent 
{
  @Input() modifierGroupsFormGroups: FormGroup[] = [];
  @Input() translations: ILanguageObject = {} as ILanguageObject;
  @Input() decimalPrecision: string = '';

  constructor(presenter: ModifiersPresenter) {
    super(presenter);
  }

  hasModifierGroups(): boolean {
    return this.presenter.hasModifierGroups();
  }

  getModifierGroupsValueByFormGroup(modifierGroup: FormGroup): ModifierGroupWrapper | null {
    return this.presenter.getModifierGroupsValueByFormGroup(modifierGroup);
  }

  minModifierSelected(modifierGroup: FormGroup): boolean {
    return this.presenter.minModifierSelected(modifierGroup);
  }

  maxModifierSelected(modifierGroup: FormGroup): boolean {
    return this.presenter.maxModifierSelected(modifierGroup);
  }

  getMinimumBadgeClass(modifierGroup: FormGroup): string {
    return this.presenter.getMinimumBadgeClass(modifierGroup);
  }

  getMaximumBadgeClass(modifierGroup: FormGroup): string {
    return this.presenter.getMaximumBadgeClass(modifierGroup);
  }

  getModifierGroupDetailsAsFormGroup(modifierGroup: FormGroup): FormGroup[] {
    return this.presenter.getModifierGroupDetailsAsFormGroup(modifierGroup);
  }

  getModifierGroupDetailByFormGroup(modifierDetail: FormGroup): ModifierDetail | null {
    return this.presenter.getModifierGroupDetailByFormGroup(modifierDetail);
  }

  isModifierSelectionDisabled(modifierDetail: FormGroup, modifierGroup: FormGroup): boolean {
    return this.presenter.isModifierSelectionDisabled(modifierDetail, modifierGroup);
  }

  shouldShowModifierBasePrice(modifierDetail: FormGroup): boolean {
    return this.presenter.shouldShowModifierBasePrice(modifierDetail);
  }

  shouldShowFreeModifierLabel(modifierDetail: FormGroup): boolean {
    return this.presenter.shouldShowFreeModifierLabel(modifierDetail);
  }

  canDecreaseModifier(modifierDetail: FormGroup): boolean {
    return this.presenter.canDecreaseModifier(modifierDetail);
  }

  canIncreaseModifier(modifierDetail: FormGroup): boolean {
    return this.presenter.canIncreaseModifier(modifierDetail);
  }

  isModifierDecreaseDisabled(modifierDetail: FormGroup): boolean {
    return this.presenter.isModifierDecreaseDisabled(modifierDetail);
  }

  isModifierIncreaseDisabled(modifierDetail: FormGroup): boolean {
    return this.presenter.isModifierIncreaseDisabled(modifierDetail);
  }

  shouldShowExtraPrice(modifierDetail: FormGroup): boolean {
    return this.presenter.shouldShowExtraPrice(modifierDetail);
  }

  shouldHideExtraPrice(modifierDetail: FormGroup): boolean {
    return this.presenter.shouldHideExtraPrice(modifierDetail);
  }

  onNoAddChange(event: Event, control: FormGroup): void {
    this.presenter.onNoAddChange(event, control);
  }

  onAddExtraChange(event: Event, control: FormGroup, modifierGroup: FormGroup): void {
    this.presenter.onAddExtraChange(event, control, modifierGroup);
  }

  decreaseDetail(modifierDetail: FormGroup): void {
    this.presenter.decreaseDetail(modifierDetail);
  }

  increaseDetail(modifierDetail: FormGroup): void {
    this.presenter.increaseDetail(modifierDetail);
  }
}
